<template>
  <div class="p-pegas">
    <div
      class="card-table"
      :class="mode ? 'card__tableday' : 'card__tablenight'"
    >
      <div class="card-table-body ifon-add-title-block">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="caz-blocks-sarcho-title">
              <div
                class="content-title d-flex align-center mr-2"
                :class="mode ? 'content__titleday' : 'content__titlenight'"
              >
                {{ $t("message.currency") }}
              </div>
              <div class="block-sarche">
                <div class="header__search">
                  <crm-input
                    :size="'small'"
                    :className="'w100'"
                    :class="mode ? 'input__day' : 'input__night'"
                    v-model="filterForm.search"
                    :icon="'el-icon-search'"
                  ></crm-input>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :span="12" class="flex-style text-right">
            <crm-create-and-column-settings
              :permission="$options.name"
              :class="mode ? 'button__settingsday' : 'button__settingsnight'"
              @c-create="drawerCreate = true"
              :columns="columns"
              @c-change="updateColumn"
              :v_can_create="'currencies.create'"
            >
            </crm-create-and-column-settings>
          </el-col>
        </el-row>
      </div>
      <!-- end ifon-add-title-block -->

      <div class="card-table-header table-crm-smart">
        <table
          class="table-my-code table-bordered"
          :class="mode ? 'table__myday' : 'table__mynight'"
          v-loading="loadingData"
        >
          <thead>
            <tr>
              <th colspan="24">
                <div
                  target="_blank"
                  title="The Central Bank of the Republic of Uzbekistan"
                >
                  <img
                    src="https://cbu.uz/en/informer/?txtclr=212121&brdclr=FFC700&bgclr=FFE27D&r_choose=USD_EUR_RUB"
                    alt=""
                  />
                </div>
              </th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th class="w50p" v-if="columns.id.show">
                {{ columns.id.title }}
              </th>

              <th v-if="columns.name.show">
                {{ columns.name.title }}
              </th>

              <th v-if="columns.symbol.show">
                {{ columns.symbol.title }}
              </th>

              <th v-if="columns.code.show">
                {{ columns.code.title }}
              </th>

              <th v-if="columns.rate.show">
                {{ columns.rate.title }}
              </th>

              <th v-if="columns.created_at.show">
                {{ columns.created_at.title }}
              </th>

              <th v-if="columns.updated_at.show">
                {{ columns.updated_at.title }}
              </th>

              <th v-if="columns.settings.show">
                {{ columns.settings.title }}
              </th>
            </tr>

            <tr class="filter_sorche">
              <th v-if="columns.id.show">
                <el-input
                  clearable
                  size="mini"
                  v-model="filterForm.id"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.id.title"
                  class="id_input"
                ></el-input>
              </th>

              <th v-if="columns.name.show">
                <crm-input
                  :placeholder="columns.name.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.name"
                ></crm-input>
              </th>

              <th v-if="columns.symbol.show">
                <crm-input
                  :placeholder="columns.symbol.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.symbol"
                ></crm-input>
              </th>

              <th v-if="columns.code.show">
                <crm-input
                  :placeholder="columns.code.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.code"
                ></crm-input>
              </th>

              <th v-if="columns.rate.show">
                <crm-input
                  :placeholder="columns.rate.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.rate"
                ></crm-input>
              </th>

              <th v-if="columns.created_at.show">
                <crm-date-picker
                  :placeholder="columns.created_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.created_at"
                ></crm-date-picker>
              </th>

              <th v-if="columns.updated_at.show">
                <crm-date-picker
                  :placeholder="columns.updated_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.updated_at"
                ></crm-date-picker>
              </th>

              <th class="settinW" v-if="columns.settings.show"></th>
            </tr>
          </thead>

          <transition-group name="flip-list" tag="tbody">
            <tr
              v-for="currency in list"
              :key="currency.id"
              class="cursor-pointer"
            >
              <td v-if="columns.id.show">{{ currency.id }}</td>

              <td v-if="columns.name.show">
                {{ currency.name }}
                <img v-if="currency.is_active" src="/img/active.png" />
              </td>

              <td v-if="columns.symbol.show">
                {{ currency.symbol }}
              </td>

              <td v-if="columns.code.show">
                {{ currency.code }}
              </td>

              <td v-if="columns.rate.show">
                {{ currency.rate }}
              </td>

              <td v-if="columns.created_at.show">
                {{ currency.created_at }}
              </td>

              <td v-if="columns.updated_at.show">
                {{ currency.updated_at }}
              </td>

              <td v-if="columns.settings.show" class="settings-td">
                <crm-settings
                  :name="$options.name"
                  :model="currency"
                  :actions="actions"
                  :permissionShow="'currencies.update'"
                  :permissionDestroy="'currencies.destroy'"
                  @edit="edit"
                  @delete="destroy"
                ></crm-settings>
              </td>
            </tr>
          </transition-group>
        </table>
        <div class="my___pagination">
          <crm-pagination
            @c-change="updatePagination"
            :class="mode ? 'pagination__day' : 'pagination__night'"
            :pagination="pagination"
          ></crm-pagination>
        </div>
      </div>

      <div class="app-modal app-modal__full">
        <el-drawer
          :with-header="false"
          :visible.sync="drawerCreate"
          size="70%"
          ref="drawerCreate"
          @opened="drawerOpened('drawerCreateChild')"
          @closed="drawerClosed('drawerCreateChild')"
        >
          <crm-create
            ref="drawerCreateChild"
            drawer="drawerCreate"
          ></crm-create>
        </el-drawer>

        <el-drawer
          :with-header="false"
          :visible.sync="drawerUpdate"
          size="70%"
          ref="drawerUpdate"
          @opened="drawerOpened('drawerUpdateChild')"
          @closed="drawerClosed('drawerUpdateChild')"
        >
          <crm-update
            :selectedItem="selectedItem"
            ref="drawerUpdateChild"
            drawer="drawerUpdate"
          ></crm-update>
        </el-drawer>
      </div>
    </div>
  </div>
</template>
<script>
import list from "@/utils/mixins/list";
import CrmCreate from "./components/crm-create";
import CrmUpdate from "./components/crm-update";
import { i18n } from "@/utils/i18n";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "CurrencyController",
  mixins: [list],
  components: {
    CrmCreate,
    CrmUpdate
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      list: "currency/list",
      columns: "currency/columns",
      pagination: "currency/pagination",
      statues: "currency/statues",
      filter: "currency/filter",
      sort: "currency/sort",
      mode: "MODE"
    }),
    actions: function() {
      return ["edit", "delete"];
    }
  },
  methods: {
    ...mapActions({
      updateList: "currency/index",
      setPagination: "currency/setPagination",
      updateSort: "currency/updateSort",
      updateFilter: "currency/updateFilter",
      updateColumn: "currency/updateColumn",
      updatePagination: "currency/updatePagination",
      show: "currency/show",
      empty: "currency/empty",
      delete: "currency/destroy",
      refreshData: "currency/refreshData"
    })
  }
};
</script>
